import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0a17663911b00140b46ff/komhunter/src/app/kom-suggestions/components/KomSuggestionsHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0a17663911b00140b46ff/komhunter/src/app/kom-suggestions/components/KomSuggestionsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0a17663911b00140b46ff/komhunter/src/components/Sidebar.tsx");
